module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// /~/styled-jsx/style.js
// module id = 1968
// module chunks = 0